// Shared Pyodide loader — reused by:
//   1. /settings/ai-code (PyodideRunner page)
//   2. AssistantPanel code-block runner (inline ▶ Run buttons)
//
// Single module-level singleton — one page reload = one Pyodide load.

const PYODIDE_VERSION = '0.28.4';
const PYODIDE_URL = `https://cdn.jsdelivr.net/pyodide/v${PYODIDE_VERSION}/full/pyodide.js`;

let _instance = null;
let _loading = null;

export async function getPyodide(onStage) {
  if (_instance) return _instance;
  if (_loading) return _loading;
  _loading = (async () => {
    if (!window.loadPyodide) {
      onStage?.('Pyodide ランタイムを読み込み中…');
      await new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = PYODIDE_URL;
        s.crossOrigin = 'anonymous';
        s.onload = resolve;
        s.onerror = () => reject(new Error(
          `Pyodide の CDN (${PYODIDE_URL}) にアクセスできません。ネットワークまたは CSP を確認してください。`));
        document.body.appendChild(s);
      });
    }
    onStage?.('Python 環境を起動中…');
    const pyodide = await window.loadPyodide({
      indexURL: `https://cdn.jsdelivr.net/pyodide/v${PYODIDE_VERSION}/full/`,
    });
    onStage?.('pandas / matplotlib を読み込み中…');
    await pyodide.loadPackage(['pandas', 'matplotlib', 'numpy']);
    await pyodide.runPythonAsync("import matplotlib\nmatplotlib.use('AGG')\n");
    _instance = pyodide;
    _loading = null;
    return pyodide;
  })();
  return _loading;
}

export async function runPython(code) {
  const py = await getPyodide();
  const buf = [];
  py.setStdout({ batched: (s) => buf.push(s) });
  py.setStderr({ batched: (s) => buf.push(s) });
  let err = null; let chart = null;
  try {
    await py.runPythonAsync(code);
    try {
      const png = py.FS.readFile('/tmp/chart.png', { encoding: 'binary' });
      const blob = new Blob([png], { type: 'image/png' });
      chart = URL.createObjectURL(blob);
      py.FS.unlink('/tmp/chart.png');
    } catch { /* no chart produced */ }
  } catch (e) {
    err = String(e.message || e);
  }
  return { output: buf.join(''), error: err, chart };
}
